type IApplyCustomSortOptions = {
  newItemsAt: 'top' | 'bottom'
}

export const applyCustomSort = <T>(
  items: T[],
  savedOrderIds: string[],
  getId: (item: T) => string,
  options: IApplyCustomSortOptions
): T[] => {
  if (!savedOrderIds.length) {
    return items
  }

  const itemsById = new Map<string, T>()
  for (const item of items) {
    itemsById.set(getId(item), item)
  }

  const orderedKnown: T[] = []
  const seenIds = new Set<string>()

  for (const id of savedOrderIds) {
    const item = itemsById.get(id)
    if (item !== undefined && !seenIds.has(id)) {
      orderedKnown.push(item)
      seenIds.add(id)
    }
  }

  const newItems = items.filter((item) => !seenIds.has(getId(item)))

  return options.newItemsAt === 'top'
    ? [...newItems, ...orderedKnown]
    : [...orderedKnown, ...newItems]
}
